import { deprecatedTimezones } from './deprecated-timezones.mjs';

function mapDeprecatedTimezones(timezone) {
  if (Object.keys(deprecatedTimezones).some(key => key === timezone)) {
    return deprecatedTimezones[timezone];
  } else {
    return timezone;
  }
}

export { mapDeprecatedTimezones };
